module.exports = __webpack_public_path__ + "media/images/lb/044-e8a3d5a0f8da12294e8d2c7dd367dcbb.svg";